export default {"src":"/_next/static/media/logo-seedz.e12d4a3b.svg","height":46,"width":171};